module.exports = __webpack_public_path__ + "media/src/assets/Images/Add-9a7d27f4ad7cf3a04b2ddd9adaeaf2fe.svg";